import { CollectionType } from '@/modules/collection/types';

const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');

const JourneyList = () => import(/* webpackChunkName: "collection" */ './view/journey.vue');
const GalleryList = () => import(/* webpackChunkName: "collection" */ './view/gallery.vue');

const CollectionAddOrEdit = () => import(/* webpackChunkName: "collection" */ './view/add.or.edit.vue');
const CollectionDetail = () => import(/* webpackChunkName: "collection" */ './view/detail.vue');
const CollectionTranslate = () => import(/* webpackChunkName: "collection" */ './view/translate.vue');

const CollectionItemList = () => import(/* webpackChunkName: "collection" */ './item/view/index.vue');
const CollectionItemAdd = () => import(/* webpackChunkName: "collection" */ './item/view/add.or.edit.vue');
const CollectionItemEdit = () => import(/* webpackChunkName: "collection" */ './item/view/add.or.edit.vue');

export const ROUTE_NAME_COLLECTION = {
    INDEX: (type: number) => (type == CollectionType.Journey ? 'JourneyList' : 'GalleryList'),
    ADD: (type: number) => (type == CollectionType.Journey ? 'CollectionJourneyAdd' : 'CollectionGalleryAdd'),
    EDIT: (type: number) => (type == CollectionType.Journey ? 'CollectionJourneyEdit' : 'CollectionGalleryEdit'),
    DETAIL: (type: number) => (type == CollectionType.Journey ? 'CollectionJourneyDetail' : 'CollectionGalleryDetail'),
    TRANSLATE: (type: number) =>
        type == CollectionType.Journey ? 'CollectionJourneyTranslate' : 'CollectionGalleryTranslate',
    ITEM: {
        INDEX: (type: number) =>
            type == CollectionType.Journey ? 'CollectionJourneyItemList' : 'CollectionGalleryItemList',
        ADD: (type: number) =>
            type == CollectionType.Journey ? 'CollectionJourneyItemAdd' : 'CollectionGalleryItemAdd',
        EDIT: (type: number) =>
            type == CollectionType.Journey ? 'CollectionJourneyItemEdit' : 'CollectionGalleryItemEdit'
    }
};

export default [
    {
        path: '/app/:appId/collection/journey',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_COLLECTION.INDEX(CollectionType.Journey),
                component: JourneyList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_COLLECTION.ADD(CollectionType.Journey),
                component: CollectionAddOrEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':collectionId/edit',
                name: ROUTE_NAME_COLLECTION.EDIT(CollectionType.Journey),
                component: CollectionAddOrEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':collectionId/detail',
                name: ROUTE_NAME_COLLECTION.DETAIL(CollectionType.Journey),
                component: CollectionDetail,
                meta: { requiresAuth: true }
            },
            {
                path: ':collectionId/translate',
                name: ROUTE_NAME_COLLECTION.TRANSLATE(CollectionType.Journey),
                component: CollectionTranslate,
                meta: { requiresAuth: true }
            },
            {
                path: ':collectionId/item/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_COLLECTION.ITEM.INDEX(CollectionType.Journey),
                        component: CollectionItemList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_COLLECTION.ITEM.ADD(CollectionType.Journey),
                        component: CollectionItemAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':collectionItemId/edit',
                        name: ROUTE_NAME_COLLECTION.ITEM.EDIT(CollectionType.Journey),
                        component: CollectionItemEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    },

    {
        path: '/app/:appId/collection/gallery',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_COLLECTION.INDEX(CollectionType.Theme),
                component: GalleryList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_COLLECTION.ADD(CollectionType.Theme),
                component: CollectionAddOrEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':collectionId/edit',
                name: ROUTE_NAME_COLLECTION.EDIT(CollectionType.Theme),
                component: CollectionAddOrEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':collectionId/detail',
                name: ROUTE_NAME_COLLECTION.DETAIL(CollectionType.Theme),
                component: CollectionDetail,
                meta: { requiresAuth: true }
            },
            {
                path: ':collectionId/translate',
                name: ROUTE_NAME_COLLECTION.TRANSLATE(CollectionType.Theme),
                component: CollectionTranslate,
                meta: { requiresAuth: true }
            },
            {
                path: ':collectionId/item/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_COLLECTION.ITEM.INDEX(CollectionType.Theme),
                        component: CollectionItemList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_COLLECTION.ITEM.ADD(CollectionType.Theme),
                        component: CollectionItemAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':collectionItemId/edit',
                        name: ROUTE_NAME_COLLECTION.ITEM.EDIT(CollectionType.Theme),
                        component: CollectionItemEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
